var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07512 17.4966C8.87986 17.3014 8.87986 16.9848 9.07512 16.7895L13.8644 12.0002L9.07512 7.2109C8.87986 7.01564 8.87986 6.69906 9.07512 6.5038C9.27039 6.30854 9.58697 6.30854 9.78223 6.5038L14.9251 11.6467C15.1203 11.8419 15.1203 12.1585 14.9251 12.3538L9.78223 17.4966C9.58697 17.6919 9.27038 17.6919 9.07512 17.4966Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.824cc54492f89c5bcdde2171edaab385.svg";
export { ForwardRef as ReactComponent };